import React from "react";
import LogoArea from "../dashboard.leftbar.component/leftbar.logoarea.component";
import Navlink from "../dashboard.leftbar.component/leftbar.navlink.component";
import MoreLinks from "../dashboard.leftbar.component/leftbar.moreLinks.component";
import Footer from "../dashboard.leftbar.component/leftbar.footer.component";
import { useHistory } from "react-router-dom";
export const Leftbar = ({ Editor, setPopStyle, Show, setShow }) => {
  let history = useHistory();
  const Path = history.location.pathname;

  return (
    <div className="leftbarWrapper">
      <div
        className="leftbarTop"
        style={{
          height: Path.toLowerCase() !== "/dashboard" ? "100%" : "",
        }}
      >
        {/* { Editor === true && (
          <div className='DashpopIcon' onClick={() => props.setDashPop(false)}>
            <span className="material-icons">
              navigate_before
            </span>
          </div>
        )} */}
        <div className="topareaWrapper">
          <div className="topareaInsider">
            <nav className="navWrapper">
              <LogoArea />
              <div className="navigationLinksWrapper">
                <div className="navigationLinksWrapperStyle">
                  <Navlink key="Nav-1" />
                </div>
              </div>
              {/* <MoreLinks /> */}
            </nav>
          </div>
        </div>
      </div>
      <Footer setPopStyle={setPopStyle} Show={Show} setShow={setShow} />
    </div>
  );
};

export default Leftbar;
